var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgWavesLanding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 248,
    viewBox: "0 0 1920 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2080.49 254.987H-30.3926V28.1801C-2.79566 24.644 24.6032 19.7043 51.6974 13.3801C215.82 -24.7139 393.829 30.0001 580.842 87.4801C825.612 162.714 1085.81 242.689 1350.48 125.52C1577.03 25.228 1852.59 93.1551 2080.49 199.32V254.987Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWavesLanding2);
export default __webpack_public_path__ + "static/media/bg-waves-landing-2.6e1ef3980ae804def60ea59ddf841deb.svg";
export { ForwardRef as ReactComponent };